import { combineReducers } from 'redux';

import servings, * as fromServings from './servings';
import mealOptions from './mealOptions';
import subtotals from './subtotals';

export default combineReducers({
  servings,
  mealOptions,
  subtotals,
});

export const selectServings = state => state.servings;
export const selectMealOptions = state => state.mealOptions;
export const selectSubtotals = state => state.subtotals;

export const selectServingsForMeal = (state, mealId) =>
  fromServings.selectServingsForMeal(selectServings(state), mealId);
